module.exports = __webpack_public_path__ + "img/SMSC1000-min.3bb1852e.png";